import App from "./App";
import ReactDOM from "react-dom";

const kickIt: () => void = () => {
  ReactDOM.render(<App />, document.getElementById("cbca-2022-app"));
};

if (document.addEventListener) {
  document.addEventListener("DOMContentLoaded", kickIt);
} else {
  (window as any).attachEvent("onload", kickIt);
}
